module.exports = __webpack_public_path__ + "img/tools.77aa4ccf.png";